module.exports = __webpack_public_path__ + "img/Logo-white.da85f527.svg";